import { PerformedByRequestDTO } from './performed-by-request-dto';
import { RequestDTO } from './request-dto';
import { TypeScopeDTO } from './type-scope-dto';

export interface SaveUserRoleContextRequestRequestDTO extends RequestDTO {
    userEmail?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    secondaryEmail?: string;
    preferredLanguageCd?: string;
    primaryPhone?: string;
    mobilePhone?: string;
    fax?: string;
    roleCd?: string;
    contextCd?: string;
    languageCd?: string;
    scopes?: TypeScopeDTO[];
    deleteRole?: boolean;
}

export interface SaveUserRoleContextExternalRequestRequestDTO extends SaveUserRoleContextRequestRequestDTO {
    requestKey?: string;
}

export interface SaveUserRoleContextInternalRequestRequestDTO extends SaveUserRoleContextRequestRequestDTO, PerformedByRequestDTO {}
